import {
    GET_SECTION_PRICES_FAIL,
    GET_SECTION_PRICES_REQUEST,
    GET_SECTION_PRICES_SUCCESS,
    RegionAction,
    RegionState,
    SET_REGION,
    SET_REGION_SUGGESTION,
} from "../types";
import { getBootstrappedRegionCode } from "../../utils/regionBootstrap";

const initialState: RegionState = {
    code: getBootstrappedRegionCode(),
    suggestion: localStorage.getItem("regionSuggestion") ?? null,
    loading: true,
    error: null,
};

const region = (state: RegionState = initialState, action: RegionAction): RegionState => {
    switch (action.type) {
        case SET_REGION:
            return { ...state, code: action.payload, loading: true };
        case SET_REGION_SUGGESTION:
            return { ...state, suggestion: action.payload };
        case GET_SECTION_PRICES_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_SECTION_PRICES_SUCCESS:
            return { ...state, loading: false };
        case GET_SECTION_PRICES_FAIL:
            return { ...state, loading: false, error: action.payload.error };
        default:
            return state;
    }
};

export default region;
